export default __webpack_public_path__ + "static/media/mem-division.ed0ab787.jpg";